import React from "react";

import { Container } from "react-bootstrap";

import AwardsComponent from "../components/Awards.component";
import BannerComponent from "../components/Banner.component";
import DocumentComponent from "../components/Document.component";
import ScheduleComponent from "../components/Schedule.component";
import i18n from "../i18n";

const Awards = (): React.JSX.Element => {
  const { t } = i18n;

  return (
    <React.Fragment>
      <DocumentComponent title={t("Awards")} />
      <BannerComponent description="" title={t("Awards")} />
      <Container className="mb-5 galleryContainer">
        <AwardsComponent />
      </Container>

      <ScheduleComponent />
    </React.Fragment>
  );
};

export default Awards;
